import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import history from './history'
import './index.css';
import App from './App';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Switch } from 'react-router-dom';

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/" component={App}>
                </Route>
            </Switch>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js